import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { de } from "./de";
import { en } from "./en";
import { it } from "./it";

export const LANGUAGES = ["de", "it", "en"] as const;
export type Language = (typeof LANGUAGES)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { de: { translation: de }, it: { translation: it }, en: { translation: en } },
    fallbackLng: "de",
    supportedLngs: LANGUAGES,
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"], lookupLocalStorage: "optitime.lang" },
  });

export function currentLanguage(): Language {
  const lang = (i18n.resolvedLanguage ?? "de").slice(0, 2);
  return (LANGUAGES as readonly string[]).includes(lang) ? (lang as Language) : "de";
}

export default i18n;
